import React, {useContext, useEffect, useState} from 'react';
import styled, {useTheme} from "styled-components";
import {useTranslation} from "react-i18next";
import Text from "./content/Text";
import Stack from "./layout/Stack";
import Box from "./layout/Box";
import IconRotateToLandscape from "./iconography/IconRotateToLandscape";
import IconRotateToPortrait from "./iconography/IconRotateToPortrait";
import EnvironmentVariablesContext
  from "../contexts/EnvironmentVariablesContext";

export const ORIENTATION_TYPES = {
  LANDSCAPE: "landscape",
  PORTRAIT: "portrait"
}

export const DEVICE_TYPES = {
  MOBILE: "mobile",
  TABLET: "tablet",
  DESKTOP: "desktop"
}

export default function EnsureOrientationOnMobile({
  orientation = null,
  children,
}) {
  const { deviceInfo } = useTheme();
  const {t} = useTranslation();
  const [lockInterface, setLockInterface] = useState(false);
  const {
    REACT_APP_LOCK_INTERFACE_ORIENTATION_BACKGROUND
  } = useContext(EnvironmentVariablesContext);

  const deviceOrientation = deviceInfo.orientation;
  const isPortableDevice = deviceInfo.deviceType === DEVICE_TYPES.TABLET ||
    deviceInfo.deviceType === DEVICE_TYPES.MOBILE

  useEffect(() => {
    if (orientation !== null) {
      const lock = isPortableDevice && !deviceInfo[orientation];
      let timer = setTimeout(
        () => setLockInterface(lock),
        lockInterface && !lock ? 1000 : 0
      );
      return () => {
        clearTimeout(timer);
      }
    }
  }, [
    deviceInfo,
    orientation,
    deviceOrientation,
    lockInterface,
    setLockInterface,
    isPortableDevice,
  ])

  if (lockInterface) {
    return (
      <Container backgroundUrl={REACT_APP_LOCK_INTERFACE_ORIENTATION_BACKGROUND}>
        <Stack space="gutter" align="center"  style={{zIndex: 1}}>
          <Box>
            {orientation === ORIENTATION_TYPES.LANDSCAPE ? (
              <IconRotateToLandscape />
            ) : (
              <IconRotateToPortrait />
            )}
          </Box>
          <Text align="center">{t('text.rotateDevice')}</Text>
        </Stack>
      </Container>
    )
  }

  return children;
}

export const EnsureLandscapeOnMobile = (props => (
  <EnsureOrientationOnMobile orientation={ORIENTATION_TYPES.LANDSCAPE} {...props} />
));

export const EnsurePortraitOnMobile = (props => (
  <EnsureOrientationOnMobile orientation={ORIENTATION_TYPES.PORTRAIT} {...props} />
));

const Container = styled.div`
  position: fixed;
  inset: 0 0;
  display: flex;
  color: #fff;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  background-image: url('${props => props.backgroundUrl}');
  background-size: cover;
  background-position: center center;

  &:before {
    display: block;
    content: "";
    position: absolute;
    inset: 0 0;
    background-color: rgba(0, 0, 0, 0.7);
  }

`;
